import { normalizeStr } from './generalFuncs';

/**
 * Vrai si `desc` contient `query`, casse et accents ignorés.
 * Requête vide ou blanche : filtre inactif, renvoie true.
 * Description absente : renvoie false dès qu'une requête est saisie.
 */
export const matchesDesc = (desc, query) => {
  const q = typeof query === 'string' ? query.trim() : '';
  if (q === '') return true;
  if (desc === null || desc === undefined || desc === '') return false;
  return normalizeStr(String(desc)).indexOf(normalizeStr(q)) > -1;
};

/**
 * Convertit une saisie utilisateur en nombre.
 * Accepte la virgule décimale et les espaces. Renvoie null si vide ou non numérique.
 * Ne reconnaît pas le point comme séparateur de milliers : "1.500,25" renvoie null (AC-20).
 */
export const parseAmount = (input) => {
  if (input === null || input === undefined) return null;
  const raw = String(input).trim().replace(/\s/g, '').replace(',', '.');
  if (raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

/**
 * Vrai si `value` est dans [min, max], bornes incluses.
 * min ou max à null : pas de limite de ce côté. Les deux à null : filtre inactif.
 * Valeur absente et au moins une borne posée : renvoie false (AC-21).
 */
export const inRange = (value, min, max) => {
  if (min === null && max === null) return true;
  if (value === null || value === undefined || value === '') return false;
  const v = Number(value);
  if (!Number.isFinite(v)) return false;
  if (min !== null && v < min) return false;
  if (max !== null && v > max) return false;
  return true;
};

/**
 * Ne conserve que les caractères d'un montant saisi : chiffres, virgule ou point
 * décimal, espace de milliers, signe moins en tête. Les lettres et symboles sont retirés,
 * ce qui empêche toute saisie non numérique dans les champs Montant.
 */
export const sanitizeAmountInput = (input) =>
  String(input === null || input === undefined ? '' : input).replace(/[^0-9.,\s-]/g, '').replace(/(?!^)-/g, '');
